import { gql } from "@apollo/client";

export const BLOCK_FIELDS = `
  id
  domain
  parentId
  schemaType
  authorId
  type
  name
  desc
  category
  data
  versionNum
  history {
    authorId
    note
    timestamp
  }
  timestamp
  updatedAt
`;

export const GET_BLOCK = gql`
  query block($id: ID!) {
    block(id: $id) {
      ${BLOCK_FIELDS}
    }
  }
`;

export const GET_BLOCKS = gql`
  query blocks($input: BlocksInput!) {
    blocks(input: $input) {
      total
      blocks {
        ${BLOCK_FIELDS}
      }
    }
  }
`;
